/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_LaunchInputs */

const en_directory_home_hero_launch = /** @type {(inputs: Directory_Home_Hero_LaunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit your product`)
};

const zh_directory_home_hero_launch = /** @type {(inputs: Directory_Home_Hero_LaunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交你的产品`)
};

/**
* | output |
* | --- |
* | "Submit your product" |
*
* @param {Directory_Home_Hero_LaunchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_launch = /** @type {((inputs?: Directory_Home_Hero_LaunchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_LaunchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_launch(inputs)
	return zh_directory_home_hero_launch(inputs)
});
export { directory_home_hero_launch as "directory.home.hero.launch" }